import { useHeadingFontOverrides } from 'utils/font-override';
import { buildCssVar } from 'utils/style-override';

import type { ComponentsBanner } from 'queries/graphql';

import styles from './styles.module.scss';

export default function Banner({ sectionId, text, style }: ComponentsBanner) {
  const { textColor, backgroundColor, headingFont } = style || {};

  const headingFontOverrides = useHeadingFontOverrides(headingFont);

  return (
    <div id={sectionId} className={`root ${styles.banner} banner`}>
      <style jsx>{`
        .root {
          ${buildCssVar('--text-color', textColor, 'var(--text-color-light)')}
          ${buildCssVar('--background-color', backgroundColor, 'var(--primary-color)')}
          ${headingFontOverrides ?? ''}
        }
      `}</style>

      <h4>{text}</h4>
    </div>
  );
}
